import React from "react";
import { ResponsiveImage } from "../../../components";
import css from '../productsPage.module.css';

const HeroBanner = () => {
  // Create hero image for the banner with horse image variants
  const heroImage = {
    id: { uuid: 'hero-banner-horse' },
    type: 'image',
    attributes: {
      variants: {
        'scaled-small': { 
          width: 400, 
          height: 200, 
          url: '/static/images/horse_run.jpg' 
        },
        'scaled-medium': { 
          width: 800, 
          height: 400, 
          url: '/static/images/horse_run.jpg' 
        },
        'scaled-large': { 
          width: 1200, 
          height: 600, 
          url: '/static/images/horse_run.jpg' 
        },
        'scaled-xlarge': { 
          width: 1600, 
          height: 800, 
          url: '/static/images/horse_run.jpg' 
        }
      }
    }
  };

  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];

  return (
    <div className={css.heroBanner}>
      <ResponsiveImage
        rootClassName={css.heroImage}
        image={heroImage}
        alt="White Camargue Horses running along the water in Aigues Mortes, France"
        variants={imageVariants}
        sizes="100vw"
      />
      <div className={css.heroContent}>
        <h1 className={css.heroTitle}>Discover Amazing Products</h1>
        <p className={css.heroSubtitle}>Find the best deals on quality items from trusted sellers</p>
      </div>
    </div>
  );
};

export default HeroBanner;